import _ from 'lodash';
import { areaService } from '@/services';
import { GUID_EMPTY } from '@/helpers';
import {
    GET_BY_ACCOUNT_ID,
    GET_BY_ID,
    ADD,
    UPDATE,
    DELETE
} from "./actions.type";
import {
    GET_ALL_REQUEST,
    GET_ALL_SUCCESS,
    GET_ALL_FAILURE,
    GET_BY_ID_REQUEST,
    GET_BY_ID_SUCCESS,
    GET_BY_ID_FAILURE,
    CLEAR_ITEMS,
    CLEAR_CURRENT_ITEM,
    UPDATE_CURRENT_ITEM,
    ADD_APPLICATION_AREA,
    REMOVE_APPLICATION_AREA
} from "./mutations.type";

function getBlankApplicationArea() {
    return {
        applicationAreaId: GUID_EMPTY,
        applicationId: GUID_EMPTY,
        areaId: null,
        name: ""
    };
}

function getBlankArea() {
    return {
        areaId: GUID_EMPTY,
        accountId: GUID_EMPTY,
        refAreaTypeId: null,
        name: "",
        active: true,
        deleted: false,
        createdDate: null,
        createdBy: null,
        createdByName: null,
        modifiedDate: null,
        modifiedBy: null,
        modifiedByName: null,
        refAreaTypeName: "",
        applicationAreas: []
    };
}

export const areas = {
    namespaced: true,
    state: {
        status: {
            loading: false,
            loaded: false,
            failed: false,
            error: null
        },
        items: [],
        currentArea: getBlankArea()
    },
    getters: {

    },
    actions: {
        [GET_BY_ACCOUNT_ID]({ commit }, accountId) {
            return new Promise((resolve, reject) => {
                commit(GET_ALL_REQUEST);

                areaService.getByAccount(accountId)
                    .then(
                        areas => {
                            commit(GET_ALL_SUCCESS, areas);
                            resolve(areas);
                        },
                        error => {
                            commit(GET_ALL_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [GET_BY_ID]({ commit }, areaId) {
            return new Promise((resolve, reject) => {
                commit(GET_BY_ID_REQUEST);

                return areaService.getById(areaId)
                    .then(
                        area => {
                            commit(GET_BY_ID_SUCCESS, area);
                            resolve(area);
                        },
                        error => {
                            commit(GET_BY_ID_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [ADD]({ dispatch, commit }, area) {
            return areaService.add(area);
        },
        [UPDATE]({ dispatch, commit }, area) {
            return areaService.update(area);
        },
        [DELETE]({ dispatch, commit }, area) {
            return areaService.deleteArea(area);
        },
    },
    mutations: {
        [GET_ALL_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_ALL_SUCCESS](state, areas) {
            state.status = { loaded: true };
            state.items = areas;
        },
        [GET_ALL_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.items = [];
        },
        [GET_BY_ID_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_BY_ID_SUCCESS](state, area) {
            state.status = { loaded: true };
            state.currentArea = area;
        },
        [GET_BY_ID_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.currentArea = getBlankArea();
        },
        [CLEAR_ITEMS](state) {
            state.items = [];
        },
        [CLEAR_CURRENT_ITEM](state) {
            state.currentArea = getBlankArea();
        },
        [UPDATE_CURRENT_ITEM](state, { field, value }) {
            // see https://ypereirareis.github.io/blog/2017/04/25/vuejs-two-way-data-binding-state-management-vuex-strict-mode/
            Object.assign(state.currentArea, {
                [field]: value
            });
        },
        [ADD_APPLICATION_AREA](state, applicationId) {
            var newAppArea = getBlankApplicationArea();
            newAppArea.applicationId = applicationId;
            state.currentArea.applicationAreas.push(newAppArea);
        },
        [REMOVE_APPLICATION_AREA](state, applicationId) {
            _.remove(state.currentArea.applicationAreas, { 'applicationId': applicationId });
        },


    }
}
